'use client';

import { Provider } from 'react-redux';
import { applyMiddleware, combineReducers, legacy_createStore as createStore } from 'redux';
import thunk from 'redux-thunk';
import { currentPage, filters } from './_reducer';
import Log from './Log';

import 'styles/legacy/application-integration.scss';
import 'styles/legacy/font.scss';
import 'styles/legacy/modules/developers.scss';

const store = createStore(combineReducers({ currentPage, filters }), applyMiddleware(thunk));

export default function Logs() {
  return (
    <div className="pt-10 md:mx-4 lg:mx-8">
      <Provider store={store}>
        <Log />
      </Provider>
    </div>
  );
}
